import * as React from "react"
import { Box } from "@mui/material"
import { ActionButton } from "@components"

import {monitoringAdminReportFilters} from "../@signals";


export default function CreateButton() {

    return <Box componet="span">
        <ActionButton
            label="Create New Execution"
            icon="hexagon-plus"
            onClick={() => {
                monitoringAdminReportFilters.value = {
                    createMode: true,
                    zone: null,
                    executions: {
                        ['Time Raw']: [],
                        ['Months Days']: [],
                        ['Months']: [],
                        ['Week Days']: []
                    }
                }
            }}
        />
    </Box>
}